module.exports = __webpack_public_path__ + "img/lapiz-copy-3.9c481213.svg";